module.exports = __webpack_public_path__ + "static/img/icmefEn.81d59f51.png";